const ScheduledOrdersPanel: React.FC = () => null;

export default ScheduledOrdersPanel;
